import React from 'react';
import { Container, TabContainer, Content, Image, Text, Title, Wrapper, SubTitle, Grey, Button, ShowTarrifs, ButtonContainer } from './styled';

function handleClick() {
    window.fbq('track', 'Lead');
    window._tmr?.push({ id: '3213734', type: 'reachGoal', goal: 'Lead' });
    window.location = '#request';
}

const Cameras = () => {
    return <Wrapper>
        <Container id='cases'>
            <TabContainer>
                <Content>
                    <Title>Видеонаблюдение для дома</Title>
                    <SubTitle>Обеспечит безопасность в вашей квартире</SubTitle>
                    <Title>Imou IPC-C22EP - S2<br/> Характеристики камеры</Title>
                    <Text>
                        <Grey>Качество изображения:</Grey> Full HD<br/>
                        <Grey>Подключение:</Grey> Wi-Fi<br/>
                        <Grey>Динамик и микрофон:</Grey> встроенный<br/>
                        <Grey>Архив видео:</Grey> облачный<br/>
                        Датчик движения и ночная съемка<br/>
                    </Text>
                    <ButtonContainer>
                        <Button onClick={() => handleClick()} >Заказать камеру</Button> <p>или перейти к <ShowTarrifs onClick={() => window.location = '#tariffs'}>тарифам</ShowTarrifs></p>
                    </ButtonContainer>
                </Content>
                <Image src='/static/images/videocontrol/dahua_cue2.png'/>
            </TabContainer>
            <TabContainer>
                <Content>
                    <Title>Видеонаблюдение для улицы и подъезда</Title>
                    <SubTitle>Обеспечит безопасность в вашем загородном доме или в подъезде</SubTitle>
                    <Title>Omny Base miniDome 2E-U<br/> Характеристики камеры</Title>
                    <Text>
                        <Grey>Качество изображения:</Grey> Full HD<br/>
                        <Grey>Микрофон:</Grey> встроенный<br/>
                        <Grey>Архив видео:</Grey> облачный<br/>
                        Датчик движения и ночная съемка<br/>
                        Антивандальный корпус
                    </Text>
                    <ButtonContainer>
                        <Button onClick={() => handleClick()} >Заказать камеру</Button> <p>или перейти к <ShowTarrifs onClick={() => window.location = '#tariffs'}>тарифам</ShowTarrifs></p>
                    </ButtonContainer>
                </Content>
                <Image min='true' src='/static/images/videocontrol/omnydom.png'/>
            </TabContainer>
        </Container>
    </Wrapper>;
};

export default Cameras;
